import { createValidation } from '../../../utils/validation';

export const createProcedureValidation = (fields) => {
  const validation = createValidation(fields);

  return {
    schema: validation.schema,
    validateProcedureData: validation.validateData,
    validateField: validation.validateField,
  };
};

export default createProcedureValidation;
